export const TABLE_KEYS = {
    DOCUMENTS: 'documents',
    DOCUMENT_PAYMENT_SCHEDULES: 'document-payment-schedules',
    CASH_MOVEMENTS: 'cash-movements',
    ACCOUNTS: 'accounts',
    COUNTERPARTS: 'counterparts',
    EMPLOYEES: 'employees',
    PRODUCTS: 'products',
    USERS: 'users',
    FORECAST_RECURRENCES: 'forecast-recurrences',
    FORECAST_PLANNING: 'forecast-planning',
    DEBTS: 'debts',
    DAILY_FORECAST: 'daily-forecast',
    COMMESSE: 'commesse',
    SERVICE_CONTRACTS: 'service-contracts',
    BILLABLE_CHARGES: 'billable-charges',
    WORK_REPORTS: 'work-reports',
    CUSTOMER_MACHINES: 'customer-machines',
    MACHINE_CHECK_PLANS: 'machine-check-plans',
    MACHINE_CHECKS: 'machine-checks',
    MACHINE_FINDINGS: 'machine-findings',
    SERVICE_TARIFFS: 'service-tariffs',
    DISTINTE_RIBA: 'distinte-riba',
    PAYMENTS: 'payments',
    SUPPORT_TICKETS: 'support-tickets',
    // Backoffice: stesso utente e stessa API, chiavi con prefisso proprio.
    BACKOFFICE_TENANTS: 'backoffice-tenants',
    BACKOFFICE_TENANT_STATISTICS: 'backoffice-tenant-statistics',
    BACKOFFICE_COMMISSIONS: 'backoffice-commissions',
    BACKOFFICE_EXPECTED_COMMISSIONS: 'backoffice-expected-commissions',
    BACKOFFICE_CONTRACTS: 'backoffice-contracts',
    BACKOFFICE_REFERRERS: 'backoffice-referrers',
    BACKOFFICE_AGENTS: 'backoffice-agents',
    BACKOFFICE_ADVISORS: 'backoffice-advisors',
    BACKOFFICE_ADMINS: 'backoffice-admins',
    BACKOFFICE_FOREIGN_VENDORS: 'backoffice-foreign-vendors',
    BACKOFFICE_ERROR_LOGS: 'backoffice-error-logs',
    BACKOFFICE_ACUBE_JOBS: 'backoffice-acube-jobs',
    BACKOFFICE_ACUBE_PAYMENTS: 'backoffice-acube-payments',
    BACKOFFICE_SEPA_PAYMENTS: 'backoffice-sepa-payments',
    BACKOFFICE_MCP_CLIENTS: 'backoffice-mcp-clients',
    BACKOFFICE_ADMIN_NOTIFICATIONS: 'backoffice-admin-notifications',
    BACKOFFICE_SUPPORT_TICKETS: 'backoffice-support-tickets',
    BACKOFFICE_SERVICE_USAGE: 'backoffice-service-usage',
    BACKOFFICE_CONTRACT_USAGE: 'backoffice-contract-usage',
    BACKOFFICE_SYSTEM_MONITOR_RUNS: 'backoffice-system-monitor-runs',
    BACKOFFICE_DELEGATED_TENANTS: 'backoffice-delegated-tenants',
};
export const VALID_TABLE_KEYS = Object.values(TABLE_KEYS);
const BACKOFFICE_TABLE_KEY_PREFIX = 'backoffice-';
export const isBackofficeTableKey = (key) => key.startsWith(BACKOFFICE_TABLE_KEY_PREFIX);
const isWebTableKey = (key) => !isBackofficeTableKey(key);
export const BACKOFFICE_TABLE_KEYS = VALID_TABLE_KEYS.filter(isBackofficeTableKey);
export const WEB_TABLE_KEYS = VALID_TABLE_KEYS.filter(isWebTableKey);
//# sourceMappingURL=table-keys.js.map